export default {
  methods: {
    notifyHttpError( e ) {
      console.log(e);
      if (e && e.response) {
        console.log(e.response);
        const { response: { data } } = e;
        const message = typeof data === 'string' ? data : e.response.data.message;
        const notifyProps = {
          color: 'danger',
          time:  10000,
          title: null,
          text:  null,
        };
        if (message) {
          notifyProps.title = 'Ошибка';
          notifyProps.text = message;
        } else if (data.error) {
          notifyProps.title = 'Ошибка';
          notifyProps.text = data.error;
        } else if (e.response.status === 403) {
          notifyProps.title = 'Ошибка доступа';
          notifyProps.text = 'Недостаточно прав';
        } else {
          notifyProps.title = 'Ошибка сервера';
          notifyProps.text = 'Повторите позже';
        }
        this.$vs.notify(notifyProps);
      }
      throw e;
      // else {
      //   this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
      // }
    },
  },
};
